import { createReducer } from 'redux-create-reducer';
import {
  fetchSitesAction,
  fetchSitesSuccessAction,
  addSiteAction,
} from '../actions/sites';

const initialState = {
  choice: [],
  isFetching: false,
};

export const sitesReducer = createReducer(initialState, {
  [fetchSitesAction]: state => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [fetchSitesSuccessAction]: (state, action) => {
    return {
      ...state,
      choice: action.payload,
      isFetching: false,
    };
  },
  [addSiteAction]: (state, action) => {
    const choice = state.choice.slice();
    choice.push(action.payload);
    return {
      ...state,
      isFetching: false,
      choice: choice,
    };
  },
});

export default sitesReducer;

export const getSites = state => state.sites.choice;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/reducers/sites.js